/**
 * Statistics Service
 * Handles fetching question statistics
 */

import { httpClient } from '../lib/httpClient';
import type { StatisticsResponse } from '../interfaces/apiInterfaces/statistics';

/**
 * Fetch question statistics
 * @param params - Optional filters (subject_id, grade_id)
 * @returns Statistics including succeeded, failed, pending graphics, and published questions
 */
export async function fetchStatistics(params?: Record<string, string | undefined>): Promise<StatisticsResponse> {
  try {
    const response = await httpClient.get<StatisticsResponse>(
      '/v1/questions/statistics',
      { params }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching statistics:', error);
    throw error;
  }
}
